import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  FormLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";

import Authorization from "./Authorization";

import {
  getMotivosCancelarRecebimento,
  putCancelarRecebimentoProntoParaRetirada,
} from "../../state/order/actions";
import { useDispatch, useSelector } from "react-redux";

import { StorageUser } from "../../main/StorageUser";

import { types } from "../../state/order/types";

const useStyles = makeStyles(() => ({
  contentTitle: {
    color: "#000",
    fontSize: "18px",
    marginTop: 0,
  },
  contentText: {
    color: "#757575",
    fontSize: "14px",
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
  radio: {
    marginRight: 0,
    borderBottom: "1px solid #E0E0E0",
  },
  textField: {
    marginTop: 15,
  },
  dialogActions: {
    justifyContent: "space-between",
    padding: "8px 24px 16px",
  },
}));

export default function CancelarRecebimentoModal(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, handleClose, codigoExterno, origem, setRefreshes } = props;

  const [openModal, setOpenModal] = useState(open);
  const [motivo, setMotivo] = React.useState("");
  const [observacao, setObservacao] = React.useState("");

  const { motivosCancelarRetirada, setModalClosed } = useSelector(
    (state) => state.orders
  );

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const disabled = motivo.length === 0;

  const handleRadio = (event) => {
    setMotivo(event.target.value);
  };

  const handleInput = (event) => {
    setObservacao(event.target.value);
  };

  const handleSubmit = async ({ nomeAutorizador, emailAutorizador } = {}) => {
    await dispatch(
      putCancelarRecebimentoProntoParaRetirada(
        origem,
        codigoExterno && codigoExterno.replace("#", "%23"),
        motivo,
        observacao,
        nomeAutorizador,
        emailAutorizador
      )
    );
    setRefreshes((refreshes) => refreshes + 1);
  };

  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  useEffect(() => {
    if (openModal) dispatch(getMotivosCancelarRecebimento());
  }, [openModal, dispatch]);

  useEffect(() => {
    if (setModalClosed) {
      setOpenModal(false);

      dispatch({
        type: types.SET_MODAL_CLOSED,
        payload: false,
      });

      setMotivo("");
      setObservacao("");
    }
  }, [setModalClosed, handleClose, dispatch]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={openModal}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <p className={classes.contentTitle}>
          Qual o motivo do cancelamento? 111
        </p>

        <p className={classes.contentText}>Selecione o motivo abaixo:</p>
        <hr className={classes.hr} />

        <RadioGroup
          aria-label="motivo"
          name="motivo"
          value={motivo}
          onChange={handleRadio}
        >
          {motivosCancelarRetirada.map((motivo) => (
            <FormControlLabel
              key={motivo.code}
              className={classes.radio}
              value={motivo.code}
              control={<Radio />}
              label={motivo.description}
            />
          ))}
        </RadioGroup>

        <TextField
          variant="outlined"
          fullWidth
          label="Inserir observação opcional"
          name="observacao"
          className={classes.textField}
          rows={1}
          value={observacao}
          onChange={(e) => handleInput(e)}
        />
      </DialogContent>

      {requireAutorizador && (
        <Authorization
          action={handleSubmit}
          disabled={disabled}
          cancel={handleClose}
          cancelText="Fechar"
          actionText="Recusar Pedido"
        />
      )}

      {!requireAutorizador && (
        <>
          <hr className={classes.hr} />
          <DialogActions className={classes.dialogActions}>
            <Button onClick={handleClose} variant="outlined">
              Fechar
            </Button>
            <Button
              onClick={() => handleSubmit()}
              variant="contained"
              color="secondary"
              startIcon={<ClearIcon />}
              disabled={disabled}
            >
              Recusar Pedido
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
